import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { RootState } from '../../../state/state';
import { ReservationServiceSelectors } from '../../reservation-service/state/reservation-service.selectors';
import { SecureFlightInfoService } from '../secure-flight-info.service';
import { reAddSecureFlightInformationForRoutedReservation, reAddSfiForRoutedReservationComplete } from './secure-flight-info.actions';
import { GenericResponseStatus } from '../../../models/generic-response-status';

@Injectable()
export class SecureFlightInfoEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);
  private readonly secureFlightInfoService = inject(SecureFlightInfoService);

  /**
   * Re-adds secure flight information for the routed reservation
   */
  reAddSecureFlightInformationForRoutedReservation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reAddSecureFlightInformationForRoutedReservation),
      withLatestFrom(this.store.select(ReservationServiceSelectors.getRoutedConfirmationCode)),
      mergeMap(([action, confirmationCode]) => {
        const request = [confirmationCode];
        return this.secureFlightInfoService.reAddSecureFlightInformation(request).pipe(
          map((response) => {
            return reAddSfiForRoutedReservationComplete(response?.response ?? null, response.status);
          }),
          catchError(() => {
            return of(reAddSfiForRoutedReservationComplete(null, GenericResponseStatus.FAILURE));
          })
        );
      }),
      catchError(() => of(reAddSfiForRoutedReservationComplete(null, GenericResponseStatus.FAILURE)))
    )
  );
}
